// extracted by mini-css-extract-plugin
module.exports = {"ContactLink":"ContactItem_ContactLink__1snDB","ContactItem":"ContactItem_ContactItem__3-Wet"};